"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.list.title': 'Il tuo piano',
};
